import { Component, OnInit, ViewChild } from '@angular/core';
import moment from 'moment';
import { SwiperComponent } from 'swiper/types';
import { ReportService } from '../../services/report.service';

@Component({
  selector: 'app-yield-guarantee',
  templateUrl: './yield-guarantee.component.html',
  styleUrls: ['./yield-guarantee.component.scss']
})
export class YieldGuaranteeComponent implements OnInit {
  @ViewChild('swiper', { static: false }) swiperMaster?: SwiperComponent;
  navSwiper;
  swiper;
  currentDatetime;
  plantList = [];
  finalList = [];
  moment = moment;
  currentIndex = 0;
  yieldTotalPage = 0;
  headerList = [
    { name: 'Plant Name', rowspan: 2, class: 'plant-name' },
    { name: 'Capacity (kWdc)', rowspan: 2 },
    { name: 'System Age', rowspan: 2 },
    { name: 'Guarantee Start Date', rowspan: 2 },
    { name: 'Milestone of 365 days', rowspan: 2 },
    { name: 'Targeted', rowspan: 1, colspan: 2 },
    { name: 'Actual', rowspan: 1, colspan: 2 },
    { name: 'Difference', rowspan: 2 },
  ];

  secondHeaderList = [
    { name: 'YTD Generation kWh', rowspan: 1 },
    { name: 'Daily Specific Yield', rowspan: 1 },
    { name: 'YTD Generation kWh', rowspan: 1 },
    { name: 'Daily Specific Yield', rowspan: 1 },
  ];


  prHeaderList = [
    { name: 'Plant Name', rowspan: 1, class: 'plant-name' },
    { name: 'Capacity (kWdc)', rowspan: 1 },
    { name: 'System Age', rowspan: 1 },
    { name: 'Guarantee Start Date', rowspan: 1 },
    { name: 'Milestone of 365 days', rowspan: 1 },
    { name: 'Commited', rowspan: 1 },
    { name: 'Actual', rowspan: 1, },
    { name: 'Difference', rowspan: 1 },
  ];
  constructor(
    private reportService: ReportService
  ) { }

  ngOnInit(): void {
    setInterval(() => { this.currentDatetime = Date.now() }, 1000);
    this.initData();
    setInterval(() => { this.initData() }, 1 * 60 * 60 * 1000); //  one hour load once
  }

  initData() {
    this.reportService.getYieldGuaranteePlants().subscribe(resp => {
      // console.log(`plant list resp >> ${JSON.stringify(resp.data)}`);
      this.plantList = resp.data.result;
      for (const plant of this.plantList) {
        plant.isYield = true;
        plant.ytdSpecificYield = plant.ytdGeneration / plant.capacity / plant.milestoneDay;
        plant.specificYield = plant.yield / plant.capacity / plant.milestoneDay;
        plant.difference = plant.yield > 0 ? ( plant.yield - plant.ytdGeneration ) / plant.yield * 100 : 0;
        plant.differenceDisplay = plant.difference < 0 ? -plant.difference : plant.difference;
      }


      const section = Math.ceil(this.plantList.length / 10);
      this.yieldTotalPage = section;
      const mockArray = [...Array(section).fill(0)];
      for (const i of mockArray) {
        let length = 10;
        if (this.plantList.length < 10) {
          length = this.plantList.length;
        }
        const partition = this.plantList.splice(0, length);
        this.finalList.push({ type: 'yield', list: partition });
      }
      console.log(`finalList >>${JSON.stringify(this.finalList)}`);

      this.reportService.getPrGuaranteePlants().subscribe(prResp => {
        const prPlantList = prResp.data.result;
        console.log(`prPlantList >> ${JSON.stringify(prPlantList)}`);
        for (const prPlant of prPlantList) {
          if (!prPlant.commitedPr) {
            prPlant.commitedPr = 0;
          }
          prPlant.difference = prPlant.commitedPr > 0 ? ( prPlant.actualPr - prPlant.commitedPr ) / prPlant.actualPr * 100 : 0;
          prPlant.differenceDisplay = prPlant.difference < 0 ? -prPlant.difference : prPlant.difference;
        }

        const prSection = Math.ceil(prPlantList.length / 10);
        const prMockArray = [...Array(prSection).fill(0)];
        for (const i of prMockArray) {
          let length = 10;
          if (prPlantList.length < 10) {
            length = prPlantList.length;
          }
          const partition = prPlantList.splice(0, length);
          this.finalList.push({ type: 'pr', list: partition });
        }
      });
    });
  }

  onNavSwiperInit(swiper) {
    this.navSwiper = swiper;
  }

  onSwiper(swiper) {
    this.swiper = swiper;
  }

  onSlideChange(swiper) {
    this.currentIndex = swiper.realIndex;
    console.log(`this.swiper.realIndex >> ${swiper.realIndex} `);
  }
}
